// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"134":"4de2b95b","161":"5a1684bf","513":"828e6b05","703":"823bc266","787":"a8b2fe1c"}[chunkId] + ".chunk.js";
};